<template>
  <div
    style="padding: 20px; height: 100%; flex-direction: column"
    class="between"
  >
    <div style="width: 100%">
      <div
        style="
          font-weight: 500;
          font-size: 16px;
          color: #1d2129;
          line-height: 20px;
          padding-bottom: 18px;
          border-bottom: 1px solid #f3f5f8;
        "
      >
        模板配置
      </div>
      <div style="padding: 20px 0 6px">
        <el-form
          ref="form"
          :model="form"
          label-width="70px"
          label-position="left"
        >
          <el-row :gutter="10">
            <el-col :span="5">
              <el-form-item label="模板名称">
                <el-input v-model="form.name" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="所属分类">
                <el-select v-model="form.cateId" clearable filterable>
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in types"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="所属行业">
                <el-select v-model="form.industryId" clearable filterable>
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in industrys"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="form.created"
                  type="daterange"
                  range-separator="——"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="是否热门">
                <el-select v-model="form.isHot" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="19">
              <div
                style="
                  width: 70px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 16px;
                  color: #ffffff;
                  line-height: 20px;
                  letter-spacing: 2px;
                  float: right;
                  cursor: pointer;
                  user-select: none;
                "
                class="center"
                @click="getList"
              >
                查询
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div
          style="
            width: 82px;
            height: 32px;
            background: #107fff;
            border-radius: 4px;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            cursor: pointer;
            user-select: none;
            gap: 8px;
            margin-bottom: 10px;
          "
          class="center"
          @click="drawer = true"
        >
          <i class="el-icon-plus"></i>
          新增
        </div>
      </div>
    </div>
    <div style="flex: 1; height: 100%; width: 100%">
      <el-table
        :data="data"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        height="100%"
      >
        <el-table-column prop="name" label="模板名称" width="120">
        </el-table-column>
        <el-table-column prop="introduction" label="简介" width="120">
        </el-table-column>
        <el-table-column prop="cateId" label="所属分类" width="100">
          <template #default="{ row }">
            {{ types[row.cateId - 1]?.label }}
          </template>
        </el-table-column>
        <el-table-column prop="industryId" label="所属行业" width="90">
          <template #default="{ row }">
            {{ industrys[row.industryId - 1]?.label }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isHot"
          label="是否热门推荐"
          width="120"
          :formatter="(value, row) => (value ? '是' : '否')"
        >
        </el-table-column>
        <el-table-column prop="label" label="标签" width="160">
        </el-table-column>
        <el-table-column prop="icon" label="图标">
          <template #default="{ row }">
            <img :src="row.icon" style="width: 30px; height: 30px" />
          </template>
        </el-table-column>
        <el-table-column prop="installNum" label="下载量"> </el-table-column>
        <el-table-column prop="created" label="创建时间" width="160">
        </el-table-column>
        <el-table-column prop="description" label="详细介绍" width="250">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template #default="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button
              type="text"
              style="color: #ff4f4f"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-top: 9px;
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        :current-page="form.pageNumber"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="模板配置"
      :visible.sync="drawer"
      :before-close="drawerClose"
      width="540px"
      :close-on-click-modal="false"
      top="6vh"
    >
      <div
        class="between"
        style="flex-direction: column; height: 100%; width: 100%"
      >
        <div class="content">
          <el-form
            ref="editFormRef"
            :model="editForm"
            label-position="top"
            :rules="rules"
          >
            <el-form-item label="模板名称" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
            <el-form-item label="模板简介" prop="introduction">
              <el-input
                v-model="editForm.introduction"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属分类" prop="cateId">
              <el-select v-model="editForm.cateId" clearable filterable>
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in types"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属行业" prop="industryId">
              <el-select v-model="editForm.industryId" clearable filterable>
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in industrys"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标签" prop="label">
              <el-select
                v-model="editForm.label"
                multiple
                filterable
                allow-create
                placeholder="请选择文章标签"
                default-first-option
              >
              </el-select>
            </el-form-item>
            <el-form-item label="是否热门推荐">
              <el-switch
                v-model="editForm.isHot"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="热门推荐图"
              prop="hotImg"
              v-if="editForm.isHot"
            >
              <el-upload
                class="uploader"
                :action="url"
                ref="uploadRef"
                :on-success="hotSuccess"
                :show-file-list="false"
                :headers="{
                  Authorization: `Bearer ${$store.getters.token}`,
                }"
              >
                <img
                  v-if="editForm.hotImg"
                  :src="editForm.hotImg"
                  class="avatar"
                />
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="详情背景图" prop="bgImg">
              <el-upload
                class="uploader"
                :action="url"
                ref="uploadRef"
                :on-success="bgImgSuccess"
                :show-file-list="false"
                :headers="{
                  Authorization: `Bearer ${$store.getters.token}`,
                }"
              >
                <img
                  v-if="editForm.bgImg"
                  :src="editForm.bgImg"
                  class="avatar"
                />
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
              <el-upload
                class="uploader"
                :action="url"
                ref="uploadRef"
                :on-success="iconSuccess"
                :show-file-list="false"
                :headers="{
                  Authorization: `Bearer ${$store.getters.token}`,
                }"
              >
                <img v-if="editForm.icon" :src="editForm.icon" class="avatar" />
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="下载量">
              <el-input v-model="editForm.installNum"></el-input>
            </el-form-item>
            <el-form-item label="详细介绍" prop="description">
              <el-input
                v-model="editForm.description"
                type="textarea"
              ></el-input
            ></el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="drawerClose">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { templatePage, updateOrAddTemplate } from "@/api/module";
import { headerCellStyle } from "@/utils/CustomUtil.js";
export default {
  data() {
    return {
      drawer: false,
      form: {
        pageSize: 10,
        pageNumber: 1,
      },
      editForm: {},
      rules: {
        name: [
          { required: true, message: "请输入模板名称", trigger: ["change"] },
        ],
        introduction: [
          { required: true, message: "请输入模板简介", trigger: ["change"] },
        ],
        cateId: [
          { required: true, message: "请选择所属分类", trigger: ["change"] },
        ],
        industryId: [
          { required: true, message: "请选择所属行业", trigger: ["change"] },
        ],
        label: [{ required: true, message: "请选择标签", trigger: ["change"] }],
        icon: [
          {
            required: true,
            message: "请上传图标",
            trigger: ["change", "blur", "input"],
          },
        ],
        bgImg: [
          {
            required: true,
            message: "请上传详情背景图",
            trigger: ["change", "blur", "input"],
          },
        ],
        hotImg: [
          {
            required: true,
            message: "请上传热门推荐图",
            trigger: ["change", "blur", "input"],
          },
        ],
        installNum: [
          {
            required: true,
            message: "请输入下载量",
            trigger: ["change"],
          },
        ],
        description: [
          { required: true, message: "请输入详细介绍", trigger: ["change"] },
        ],
      },
      data: [],
      loading: false,
      total: 0,
      url: `${process.env.VUE_APP_BASE_URL}/cloud-admin/file/upload?type=0`,
      types: [
        { label: "CRM/销售", value: "1" },
        { label: "ERP/生产", value: "2" },
        { label: "进销存/仓库", value: "3" },
        { label: "人事/行政", value: "4" },
        { label: "项目/任务", value: "5" },
        { label: "财务/报销", value: "6" },
        { label: "工单/售后", value: "7" },
        { label: "采招/供应", value: "8" },
      ],
      industrys: [
        { label: "制造业", value: "1" },
        { label: "金融业", value: "2" },
        { label: "贸易零售", value: "3" },
        { label: "建筑工程", value: "4" },
        { label: "医疗健康", value: "5" },
        { label: "物流运输", value: "6" },
        { label: "能源矿产", value: "7" },
        { label: "教育培训", value: "8" },
        { label: "地产物业", value: "9" },
        { label: "互联网科技", value: "10" },
        { label: "其他行业", value: "11" },
      ],
    };
  },
  methods: {
    handleSave() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          const res = await updateOrAddTemplate({
            ...this.editForm,
            label: this.editForm.label.join(","),
          });
          console.log(res);
          if (res.code === 200) {
            this.$message.success("保存成功");
            this.drawerClose();
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        } else {
          return false;
        }
      });
    },
    bgImgSuccess(response) {
      this.$set(this.editForm, "bgImg", response.data);
    },
    iconSuccess(response) {
      this.$set(this.editForm, "icon", response.data);
    },
    hotSuccess(response) {
      this.$set(this.editForm, "hotImg", response.data);
    },
    drawerClose() {
      this.$refs.editFormRef.resetFields();
      this.editForm = {};
      this.drawer = false;
    },
    headerCellStyle,
    async getList() {
      const res = await templatePage(this.form);
      this.data = res.data.records;
      this.total = res.data.total;
    },
    handleSizeChange(val) {
      if (!this.total) return;
      this.form.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      if (!this.total) return;
      this.form.pageNumber = val;
      this.getList();
    },
    handleEdit(row) {
      console.log(row);
      this.editForm = { ...row, label: row.label?.split(",") };

      this.drawer = true;
    },
    handleDelete(row) {
      console.log(row);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content {
  line-height: 32px;
}
/deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-form-item__label {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__icon {
  line-height: 24px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 22px;
}
/deep/.el-input__icon {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__close-icon {
  line-height: 24px;
}

/deep/.el-date-editor .el-range-separator {
  color: #bfbfbf;
}
.header {
  height: 60px;
  padding: 20px;
  border-bottom: 1px solid #ebecee;
  width: 100%;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 20px;
  }
  .el-icon-close {
    cursor: pointer;
  }
}

.content {
  width: 100%;
  .el-select {
    width: 100%;
  }
}

.footer {
  height: 66px;
  border-top: 1px solid #ebecee;
  width: 100%;
  padding-left: 20px;
}

.uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader /deep/.el-upload:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 105px;
  height: 105px;
  line-height: 105px;
  text-align: center;
}
.avatar {
  width: 105px;
  height: 105px;
  display: block;
}

/deep/.el-dialog__body {
  height: 69vh;
  overflow: auto;
}
</style>